import React from "react";
import { DataManColumnState } from "./types/columns";
import { DataManCellState, DataManRowState } from "./types/data";
import { DataManState } from "./types/state";
import { BuiltInViewModes, ViewModes } from "./types/view-modes";
import {
  DataManCompactViewColumnTitle,
  DataManCompactViewHierarchyColumnTitle
} from "./view-modes/compact/DataManCompactViewColumnTitle";
import { DataManCompactViewWrapper } from "./view-modes/compact/DataManCompactViewWrapper";
import { DataManTableViewColumnTitle } from "./view-modes/table/DataManTableViewColumnTitle";
import { DataManTableViewHierarchyColumnTitle } from "./view-modes/table/DataManTableViewHierarchyColumnTitle";
import { DataManTableViewWrapper } from "./view-modes/table/DataManTableViewWrapper";

export const DataManContext = React.createContext<DataManState | undefined>(
  undefined
);
export const DataManColumnContext = React.createContext<
  DataManColumnState | undefined
>(undefined);
export const DataManRowContext = React.createContext<
  DataManRowState | undefined
>(undefined);
export const DataManCellContext = React.createContext<
  DataManCellState | undefined
>(undefined);

export const viewModels: ViewModes = {
  table: {
    Wrapper: DataManTableViewWrapper,
    HierarchyColumnTitle: DataManTableViewHierarchyColumnTitle,
    ColumnTitle: DataManTableViewColumnTitle
  },
  compact: {
    Wrapper: DataManCompactViewWrapper,
    HierarchyColumnTitle: DataManCompactViewHierarchyColumnTitle,
    ColumnTitle: DataManCompactViewColumnTitle
  }
};

export const defaultViewModeKey: BuiltInViewModes = "table" as const;
